import { render, staticRenderFns } from "./taxi-course-drawer.vue?vue&type=template&id=7a162a0f&scoped=true"
import script from "./taxi-course-drawer.vue?vue&type=script&lang=js"
export * from "./taxi-course-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a162a0f",
  null
  
)

export default component.exports